<template>
    <div id="informationBar" ref="informationBar" :style="{fontSize:language=='EN'?'0.7rem':'1rem' }">
        <!-- <div class="content">
            <div class="address" v-for="item in informationBar">
                <div>{{ item.label }}：</div>
                <div v-html="item.value" class="address-value"></div>
            </div>
        </div> -->
        <div style="width: 80%;" class="pc">
            <div class="informationBar_top">
                <div class="informationBar_top_left">
                    <div class="informationBar_top_left_logo">
                        <img :src="language=='EN'?require('../../public/image/tabbarENLOGo.png'):require('../../public/image/tabbar_logo3.png')" alt="">
                    </div>
                    <div class="informationBar_top_left_info">
                        <div class="informationBar_top_left_info-left">
                            <div v-for="item in infoList" :key="item.id" class="detail_info">
                                <img :src="item.imgUrl" alt="">
                                <div class="line22" style="width: 2px;"></div>
                                <!-- <div class="info">{{ $t('companyInfo',{title:item.title,enTitle:item.enTitle}) }}:{{ informationBar[item.value].value }}</div> -->
                                <div class="info">{{ language=='zh'?item.title +':':''}}{{ informationBar[item.value]?.value }}</div>
                            </div>
                        </div>
                        <div class="informationBar_top_left_info-right">
                            <img src="../../public/image/qr.jpg" alt="">
                            <div>{{ $t('WeChatTitle') }}</div>
                        </div>
                    </div>
                </div>
                <div class="informationBar_top_right">
                    <div class="informationBar_top_right_navigation">
                        <div v-for="(item, index) in list" :key="index" class="navigation_title">{{
                            $t('navTitle', { title: item.title, enTitle: item.enTitle }) }}</div>
                    </div>
                    <div class="informationBar_top_right_line"></div>
                    <div class="informationBar_top_right_detailInfo">
                        <div v-for="(item, index) in list" :key="index" class="detailInfo_title">
                            <div v-for="(item2, index2) in item.detail" :key="index2" class="linkTag"
                                @click="changeNavName(item2.linkUrl, item2.name)">{{
                                    $t('navTitle', { title: item2.title, enTitle: item2.enTitle }) }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="record">{{ $t('record') }}：<div v-html="informationBar[3]?.value"></div>
            </div>
        </div>


        <div class="phone">
            <div class="phone-container">
                <img src="../../public/image/qr.jpg" alt="" style="margin-bottom: 0.5rem;">
                <div style="display: flex;">
                    <img src="../../public/image//wx.png" alt="" style="width: 1.5rem;margin-right: 0.2rem;">
                    {{ $t('follow') }}
                </div>
                <div>{{ $t('getInfo') }}</div>
                <div style="margin: 0.5rem 0;">{{ $t('descriptionInfo') }}</div>
            </div>
            <div class="phone-record-number">
                <div style="display: flex;">{{ $t('record') }}：<div v-html="informationBar[3]?.value"
                        style="color: #9cdcfe !important;"></div>
                </div>
                <div>{{ $t('copyright') }}</div>
            </div>
        </div>
    </div>
</template>

<script>


import { mapState } from 'vuex'
export default {
    name: 'informationBar',

    data() {
        return {
            list: [
                {

                    title: '首页',
                    enTitle: 'Home Page',
                    detail: [
                        {
                            title: '产品服务',
                            linkUrl: '/home',
                            name: 'home',
                            enTitle: 'Product Service'
                        },
                        {
                            title: '关于瑞集',
                            linkUrl: '/home',
                            name: 'home',
                            enTitle: 'About Ruiji'
                        },
                        {
                            title: '人才招聘',
                            linkUrl: '/home',
                            name: 'home',
                            enTitle: 'Talent Recruitment'
                        },

                        {
                            title: '联系我们',
                            linkUrl: '/home',
                            name: 'home',
                            enTitle: 'Contact Us'
                        },

                    ]
                },
                {
                    title: '产品',
                    enTitle: 'Product',
                    detail: [
                        {
                            title: '推荐产品',
                            linkUrl: '/product/allProduct',
                            name: 'product',
                            enTitle: 'Recommended Products',
                        },
                    ]
                },

                {
                    title: '关于我们',
                    enTitle: 'About Us',
                    detail: [
                        {
                            title: '运营理念',
                            linkUrl: '/about',
                            name: 'about',
                            enTitle: 'Operational Philosophy'
                        },
                        {
                            title: '公司资质',
                            linkUrl: '/about',
                            name: 'about',
                            enTitle: 'Company Qualifications'
                        },
                    ]
                },
                {
                    title: '新闻中心',
                    enTitle: 'News Center',
                    detail: [
                        {
                            title: '公司新闻',
                            linkUrl: '/newsCenter',
                            name: 'newsCenter',
                            enTitle: 'Company News',
                        },
                    ]
                },
                {
                    title: '联系我们',
                    enTitle: 'Contact Us',
                    detail: [
                        {
                            title: '联系地址',
                            linkUrl: '/contact',
                            name: 'contact',
                            enTitle: 'Contact Address',
                        },
                    ]
                },
                {
                    title: '招聘中心',
                    enTitle: 'Recruitment Center',
                    detail: [
                        {
                            title: '联系邮箱',
                            linkUrl: '/recruitmentCenter',
                            name: 'recruitmentCenter',
                            enTitle: 'Contact Email',
                        },
                    ]
                },
            ],
            infoList: [
                {
                    id: 1,
                    imgUrl: require('../../public/image/phone2.png'),
                    title: '电话',
                    value: 1,
                    enTitle: 'Tel'
                },
                {
                    id: 2,
                    imgUrl: require('../../public/image/地址.png'),
                    title: '地址',
                    value: 0,
                    enTitle: 'Address'
                },
                {
                    id: 3,
                    imgUrl: require('../../public/image/邮箱-(1).png'),
                    title: '邮箱',
                    value: 2,
                    enTitle: 'Email'
                },
            ],
            language: localStorage.getItem('change-language')
        }
    },
    mounted() {
        this.getInfo()
        // console.log('我加载了')
        const _this = this
       


    },
    methods: {
        getInfo() {
            this.$store.dispatch('aboutUs/getButtonConnection')
        },
        changeNavName(path, name) {
            this.$bus.$emit('changeName', name)
            this.$router.push({
                path
            })
        }
    },
    computed: {
        ...mapState('aboutUs', ['informationBar']),
    }

}
</script>

<style lang="scss" scoped>
#informationBar {
    background-color: #191919;
    color: #fff;
    // height: 250px;
    padding: 4rem 0;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;

    .pc {
        .informationBar_top {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 3.5rem;

            .informationBar_top_left {
                flex: 1;
                margin-right: 2rem;

                .informationBar_top_left_logo {
                    margin-bottom: 3.5rem;

                    img {
                        width: 8rem
                    }
                }

                .informationBar_top_left_info {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;

                    .informationBar_top_left_info-left {
                        .detail_info {
                            display: flex;
                            color: #fff !important;
                            margin: 1rem 0;
                            align-items: center;

                            img {
                                width: 1rem;
                                height: 1rem;
                                //    padding-right: 1rem;
                            }

                            .line22 {
                                width: 2px !important;
                                background-color: #f7f7f7;
                                height: 1rem;
                                margin: 0 1rem;
                            }
                        }
                    }

                    .informationBar_top_left_info-right {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        // margin-right: 2rem;

                        img {
                            width: 5rem;
                            height: 5rem;

                        }
                    }
                }
            }

            .informationBar_top_right {
                flex: 1;
                margin-left: 1rem;
                height: 100%;
                line-height: 1.5;

                .informationBar_top_right_navigation,
                .informationBar_top_right_detailInfo {
                    display: flex;
                    justify-content: space-between;
                    align-items: left;
                    line-height: 2;

                    // align-items: center;
                    .navigation_title {
                        // width: 16.6%;
                        min-width: 9rem;
                        // display: flex;
                        // align-items: center;
                        // justify-content: center;
                        text-wrap: nowrap;

                    }

                    .detailInfo_title {
                        min-width: 9rem;

                        // width: 16.6%;
                        display: flex;
                        flex-direction: column;
                        // align-items: center;

                        // .active{
                        //     color: #23a8e5;
                        // }
                        .linkTag {
                            cursor: pointer;
                            color: #fff;
                            text-decoration: none;
                            min-width: 9rem;

                            &:hover {
                                color: #23a8e5;

                            }
                        }
                    }


                }

                .informationBar_top_right_line {
                    height: 2px;
                    width: 100%;
                    background-color: #fff;
                    margin: 0.5rem 0;
                }
            }
        }

        .record {
            border-top: 2px solid #fff;
            padding: 0.5rem 0;
            display: flex;

            :deep(a) {
                color: #9cdcfe !important;
            }
        }
    }

    .phone {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        // position: absolute;
        // bottom: 0;
        display: none;

        .phone-container {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
        }

        .phone-record-number {
            width: 100vw;
            // background-color: #1d2228;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            margin-top: 1rem;
            // padding-bottom: 4rem;
        }

        img {
            width: 8rem
        }
    }
}

@media screen and (max-width: 767px) {

    #informationBar {
        // height: 250px;
        background-color: #202930;
        padding: 2rem 0 !important;
        // padding-bottom: 0rem;
        font-size: 13px !important;

        .content {

            flex-direction: column;
            justify-content: center;
            align-items: center;
            line-height: 3;
        }

        .pc {
            display: none !important;
        }

        .phone {
            display: flex !important;

        }
    }

}

@media screen and (min-width: 768px) and (max-width: 992px) {
    #informationBar {
        // height: 250px;
        background-color: #202930;
        display: flex;
        justify-content: center;
        align-items: center;

        .content {

            flex-direction: column;
            justify-content: center;
            align-items: center;
            line-height: 3;
        }

        .pc {
            display: none !important;
        }

        .phone {
            display: flex !important;

        }
    }
}
</style>